/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.models{
    export class RelatedClaimProcessTypeModel {
        public relatedClaimProcessTypes: Wars.Domain.Model.RelatedClaimProcessType[];
        public selectedRelatedClaimProcessType: Wars.Domain.Model.RelatedClaimProcessType;
        public fields: any[] = [];
        public selectedField:any;
        public claims: Wars.Domain.Model.ClaimDefinition[];
        public selectedClaimUniqueId:string;

        constructor(private processConfigurationId: string,
            private relatedClaimProcessTypeService: services.RelatedClaimProcessTypeService,
            private processConfigurationService: services.ProcessConfigurationService) {
            this.relatedClaimProcessTypeService.getRelatedClaims(processConfigurationId)
                .then(r => {
                    this.relatedClaimProcessTypes = r;
                    //console.log(this.relatedClaimProcessTypes);
                });

            this.processConfigurationService.getExpandFields(processConfigurationId)
                .then(p => {
                    p.myForms.forEach(form => {
                        Enumerable.from(form.mySteps)
                            .selectMany(s => s.formSections)
                            .selectMany(s => s.fields)
                            .where(f => f.autoCompleteConfiguration_id != null)
                            .forEach(f => {
                                this.fields.push({
                                    field: f,
                                    formId: form.id
                                });
                            });
                    });

                    //console.log(this.fields);
                });
        }

        public add() {
            this.selectedRelatedClaimProcessType = this.relatedClaimProcessTypeService
                .createNewRelatedClaimProcessType();
            this.selectedRelatedClaimProcessType.processConfiguration_id = this.processConfigurationId;
            this.selectedRelatedClaimProcessType.field_id = this.selectedField.field.id;
            this.relatedClaimProcessTypes.push(this.selectedRelatedClaimProcessType);

            this.save();
        }

        public addClaim() {
            let newRelatedClaim = this.relatedClaimProcessTypeService.createNewRelatedClaim();
            newRelatedClaim.claimUniqueId = this.selectedClaimUniqueId;
            (<any>newRelatedClaim).type = Enumerable.from(this.claims).single(claim => claim.uniqueIdentifier === this.selectedClaimUniqueId).type;

            this.selectedRelatedClaimProcessType.relatedClaims.push(newRelatedClaim);
            this.save();
        }

        public removeClaim(claim:Wars.Domain.Model.RelatedClaim) {
            claim.entityAspect.setDeleted();
            this.save(); 
        }

        public edit(relatedClaimProcessType: Wars.Domain.Model.RelatedClaimProcessType) {
            this.selectedRelatedClaimProcessType = relatedClaimProcessType;
            this.processConfigurationService
                .getRelatedProcessTypeClaims(relatedClaimProcessType.field.autoCompleteConfiguration.processType_id)
                .then(c => {
                    this.claims = c;
                    this.selectedRelatedClaimProcessType.relatedClaims.forEach(c => {
                        (<any>c).type=Enumerable.from(this.claims).single(claim => claim.uniqueIdentifier === c.claimUniqueId).type;
                    }); 
                });
        }

        public save() {
            this.relatedClaimProcessTypeService.saveAllChanges();
        }

    }
}

